'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FullScreenErrorModal = require('../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var BrowserCookieFullScreenWarning = function BrowserCookieFullScreenWarning(props) {
    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        null,
        _react2.default.createElement(
            'h2',
            null,
            'Sorry, you need to enable storage to use Milanote'
        ),
        _react2.default.createElement(
            'p',
            { className: 'explanation' },
            'Milanote uses your browser\'s storage to save data while you\'re working, please enable it and try again.'
        ),
        _react2.default.createElement(_ModalActionsList2.default, { actions: [{ text: 'Find out more', href: 'http://www.whatarecookies.com/' }] })
    );
}; // Lib


BrowserCookieFullScreenWarning.propTypes = {};

exports.default = BrowserCookieFullScreenWarning;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/browserSupport/BrowserCookieFullScreenWarning.js
// module id = 1759
// module chunks = 0